import { faPlusCircle, faTrashCan } from '@fortawesome/pro-light-svg-icons'
import { TableRowProps } from 'react-virtualized'
import { defaultRowRenderer } from 'react-virtualized/dist/es/Table'
import TwinIcon from '../../../baseComponents/TwinIcon'
import { RowData } from '../../../baseComponents/TwinTable/types'

export const displayUnitsIcon = (allRowData: RowData, addFnc: (rowIndex: number) => void, deleteFnc: (rowIndex: number) => void) => {
    if (allRowData?.tag?.includes('[')) {
        return <TwinIcon icon={faTrashCan} onClick={() => deleteFnc(allRowData.absoluteIndex || allRowData.rowIndex)} />
    }
    return <TwinIcon icon={faPlusCircle} onClick={() => addFnc(allRowData.absoluteIndex || allRowData.rowIndex)} />
}

export const pricesRowRender = (props: TableRowProps) => {
    let className = props.className
    if (props?.rowData?.tag?.includes('[')) {
        className += ' bg-gray-F7'
    }
    if (props.rowData.deleted) {
        className += ' bg-red-FF'
    }
    return defaultRowRenderer({ ...props, className})
}